import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Select, Typography } from "@mui/material";
import pdfIcon from "../../assets/svg/Pdf.svg";
import MenuItem from "@mui/material/MenuItem";
import "./DaysCard.scss";

const DayCard = ({
  tagName,
  actualFilesListData,
  handleChange,
  cardIndex,
  selectedFiles,
}) => {
  return (
    <>
      <Card className="day-card-box">
        <CardContent className="dayCard-content">
          <Typography className="txt-day" variant="subtitle2">
            {tagName}
          </Typography>
          <div className="dayCard-wrap">
            <img className="daycard-pdfIcon" src={pdfIcon} alt="Pdf Icon"></img>

            <Select
              className="daycardSelect"
              // readOnly={localStorage.ocrReInitiate === "true"}
              fullWidth
              size="medium"
              labelId="demo-select-small"
              id="demo-select-small"
              value={selectedFiles[cardIndex]?.pdfName}
            >
              <MenuItem
                value=""
                onClick={(e) => handleChange(cardIndex, "", "", "")}
              ></MenuItem>

              {actualFilesListData?.map((item, index) => (
                <MenuItem
                  key={index}
                  value={item?.file_name}
                  onClick={(e) =>
                    handleChange(
                      cardIndex,
                      item?.file_name,
                      item?.file_url,
                      tagName
                    )
                  }
                >
                  {item?.file_name}
                </MenuItem>
              ))}
            </Select>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default DayCard;
